import React from 'react'

const CopySubdomain = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g transform="translate(2 2)" stroke="#000" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <rect width="14" height="14" rx="3" />
                <path d="M18 20H8a2 2 0 0 1-2-2v-4h6a2 2 0 0 0 2-2V6h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2z" />
            </g>
        </svg>
    )
}
export default CopySubdomain
